<div class="plp container" *ngIf="model$ | async as model; else pageLoader">
  <ng-container *ngIf="!!model.pagination?.totalResults; else noResults">
    <ng-container *ngIf="{ heading: seoHeading$ | async } as seo">
      <div class="row mt-3 mb-4 d-none d-lg-flex">
        <ng-container *ngIf="isDesktop$ | async">
          <h1 *ngIf="seo.heading" class="my-3 fw-normal fs-4">
            {{ seo.heading }}
          </h1>
        </ng-container>
        <rrs-active-facets class="col-lg-10"></rrs-active-facets>
        <div class="col-2 text-end">
          <span
            >{{
              (model.pagination.exhaustiveNbHits ? '' : '~') +
                model.pagination?.totalResults
            }}&nbsp;{{ 'rrs.productListing.itemsFound' | cxTranslate }}</span
          >
          <div>
            {{ 'rrs.productListing.view' | cxTranslate }}
            <a
              [routerLink]="[]"
              [queryParams]="{
                pageSize: null,
                currentPage:
                  model.pagination?.pageSize === pageSizeOptions.default
                    ? model.pagination?.currentPage
                    : 0
              }"
              queryParamsHandling="merge"
              class="text-decoration-underline"
              data-cy="viewLessItems"
              [class.fw-bold]="
                model.pagination?.pageSize === pageSizeOptions.default
              "
              >{{ pageSizeOptions.default }}</a
            >
            {{ 'rrs.productListing.or' | cxTranslate }}
            <a
              [routerLink]="[]"
              [queryParams]="{
                pageSize: pageSizeOptions.increased,
                currentPage:
                  model.pagination?.pageSize === pageSizeOptions.increased
                    ? model.pagination?.currentPage
                    : 0
              }"
              queryParamsHandling="merge"
              class="text-decoration-underline"
              data-cy="viewMoreItems"
              [class.fw-bold]="
                model.pagination?.pageSize === pageSizeOptions.increased
              "
              >{{ pageSizeOptions.increased }}</a
            >
            {{ 'rrs.productListing.items' | cxTranslate }}
          </div>
        </div>
      </div>
      <div
        class="plp__actions d-flex gap-2 gap-lg-0 flex-nowrap position-relative pb-4 pb-lg-0">
        <div class="flex-grow-1 flex-grow-lg-0 col-lg-3 text-truncate">
          <rrs-store-facet></rrs-store-facet>
        </div>
        <div class="col-lg-9 d-flex d-lg-block align-items-center">
          <div
            class="mb-3 justify-content-end justify-content-lg-between d-flex">
            <rrs-pagination
              [pagination]="model.pagination!"
              class="d-none d-lg-flex"
              queryParam="currentPage"></rrs-pagination>
            <cx-sorting
              [sortOptions]="model.sorts!"
              (sortListEvent)="sortList($event)"
              class="plp__sorting mt-2 mt-lg-0 me-2 me-lg-0"
              data-cy="sorting"
              [selectedOption]="model.pagination?.sort || 'Relevance'"
              placeholder="{{ 'rrs.productListing.sortBy' | cxTranslate }}">
            </cx-sorting>
            <rrs-facet-list-button
              class="d-block d-lg-none mt-2 mt-lg-0"></rrs-facet-list-button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-0 col-lg-3">
          <rrs-facet-list
            [class.dialog]="hasFacetDialogTrigger$ | async"
            [class.active]="isFacetDialogOpen$ | async"
            [isInDialog]="isFacetDialogOpen$ | async"></rrs-facet-list>
        </div>
        <div class="col-12 col-lg-9">
          <ng-container *ngIf="!isDesktop$ | async">
            <h1
              *ngIf="seo.heading"
              class="my-3 d-block d-lg-none fw-normal fs-4">
              {{ seo.heading }}
            </h1>
          </ng-container>
          <div
            rrsInternalLink
            class="row g-0"
            *ngIf="{ viewType: viewType$ | async } as viewData">
            <ng-container *ngFor="let product of model.products; let i = index">
              <rrs-product-card
                [product]="product"
                [queryParams]="queryParams$ | async"
                class="col-lg-4"
                data-cy="productCard"
                [ngClass]="{ 'col-6': viewData.viewType === viewModes.Grid }"
                [position]="i">
              </rrs-product-card>

              <!-- Contentstack/DY PLP placeholder -->
              <ng-container
                *ngIf="
                  gridPlaceholderSettings$ | async as gridPlaceholderSettings
                ">
                <ng-container
                  *ngIf="gridPlaceholderSettings.get(i); let gridSettings">
                  <div
                    [class.d-none]="
                      !gridSettings?.enable_loading_skeleton ||
                      model.pagination.currentPage
                    "
                    class="col-lg-4 col-6 product-grid-placeholder d-flex flex-column justify-content-center placeholder-position-{{
                      gridSettings?.index
                    }}
                ">
                    <ng-container
                      *ngIf="gridSettings?.image_file?.url; else skeletonTmpl">
                      <a
                        [href]="gridSettings?.url_link?.href"
                        [title]="gridSettings?.url_link?.title"
                        ><img
                          class="w-100"
                          [src]="gridSettings | rrsPlpItemImageSrc | async"
                          [alt]="gridSettings.alt_text"
                      /></a>
                    </ng-container>

                    <ng-template #skeletonTmpl>
                      <div
                        class="d-flex align-items-center justify-content-center w-100 h-100">
                        <div class="placeholder-glow w-100">
                          <div class="placeholder col-8"></div>
                          <div class="placeholder col-9"></div>
                          <div class="placeholder col-10"></div>
                          <div class="placeholder col-12"></div>
                          <div class="placeholder col-8"></div>
                          <div class="placeholder col-9"></div>
                          <div class="placeholder col-11"></div>
                          <div class="placeholder col-12"></div>
                        </div>
                      </div>
                    </ng-template>
                  </div>
                </ng-container>
              </ng-container>
              <!-- END OF: Contentstack/DY PLP placeholder -->
            </ng-container>
          </div>
          <div
            class="mt-3 d-flex flex-column-reverse flex-sm-row align-items-center justify-content-between">
            <span
              >{{
                (model.pagination.exhaustiveNbHits ? '' : '~') +
                  model.pagination?.totalResults
              }}&nbsp;{{ 'rrs.productListing.itemsFound' | cxTranslate }}</span
            >
            <rrs-pagination
              [pagination]="model.pagination!"
              (viewPageEvent)="onPaginationChange()"
              queryParam="currentPage"
              class="p-0"></rrs-pagination>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
  <ng-template #noResults>
    <cx-page-slot position="no_results_slot"></cx-page-slot>
    <div
      class="plp__no-results d-flex align-items-center flex-column my-4"
      data-cy="noResults">
      <a
        [routerLink]="{ cxRoute: 'home' } | cxUrl"
        class="btn btn-primary btn-sm text-uppercase">
        {{ 'rrs.productListing.continueShopping' | cxTranslate }}
      </a>
      <span class="plp__no-results-message mt-2">{{
        'rrs.productListing.noResults' | cxTranslate
      }}</span>
    </div>
  </ng-template>
</div>

<ng-template #pageLoader>
  <div class="d-flex align-items-center justify-content-center p-5">
    <div class="spinner-border" role="status" style="width: 6rem; height: 6rem">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</ng-template>
